/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export type FileExplorerItemType = 'DIRECTORY' | 'OBJECT';

export const VirusScanStatusType = {
  Quarantined: 'quarantined',
  Scanned: 'scanned',
  Unknown: 'unknown',
  Unscanned: 'unscanned',
};

export type VirusScanStatus = 'quarantined' | 'scanned' | 'unknown' | 'unscanned';
export type AccessControlList = (typeof AccessControlListValues)[keyof typeof AccessControlListValues];
export const AccessControlListValues = {
  PRIVATE: 'private',
  PUBLIC_READ: 'public',
};

export type VersionRecord = {
  versionId: string;
};

export interface EntityFileExplorerItem {
  access?: AccessControlList;
  contentType?: string;
  createdAt?: string;
  id: string;
  lastModified?: string;
  path: string;
  previewURL?: string;
  size?: number;
  type: FileExplorerItemType;
  urls: Array<string>;
  versionID?: Array<VersionRecord>;
  virusScanStatus?: VirusScanStatus;
}
